export default "__VITE_ASSET__DtOve8ob__"